<template>
<div v-if="!loading">
  <loading
    :active.sync="loading"
    :can-cancel="false"
    :is-full-page="true"
    :height="150"
    :width="180"
    :color="'#FFFF00'"
    :background-color="'#000000'"
    :opacity="0.5"
  ></loading>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        searchnew: this.search,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:new="createHandler"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
       v-on:cancel="cancelHandler"
      v-on:delete="isConfirm = !isConfirm"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
    <div v-if="isConfirm">
      <app-confirm
        v-bind:parentObject="{
          pageTitleValue: this.pageTitleValue,
          isConfirm: this.isConfirm,
        }"
        v-on:confirm="deleteHandler($event)"
        v-on:cancelConfirm="isConfirm = !isConfirm"
      />
    </div>
  </div>
<!-- </div> -->
</template>

<script>
import moment from "moment";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

import CaseSubjectMaintenanceForm from "../../../components/industrialrelations/casesubjectmaintenance/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": CaseSubjectMaintenanceForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
    Loading,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('ircasemaintenance.editirstaffcasemaintenancelist'),
      pageTitleValue: "",
      formData: {
        id: null,
        casesubdetail: [],
        ircaseid: null,
        shortdesc: null,
        longdesc: null,
        incidentdate: null,
        stamp: 0,
        userid: this.$store.getters.userId
      },
      casesubid: [],
      loading : true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadCaseSubtHandler() {
      const vm = this;
      vm.loading = true;

      this.$store.dispatch('get', {url: "/casesubmaintenance/" + this.id})
        .then((res) => {
          vm.formData.id = res.data.rec[0].id;
          vm.formData.ircaseid = res.data.rec[0].ircaseid;
          vm.formData.shortdesc = res.data.rec[0].shortdesc,
          vm.formData.longdesc = res.data.rec[0].longdesc,
          vm.formData.incidentdate = res.data.rec[0].incidentdate,
          vm.formData.stamp = res.data.rec[0].stamp;

          vm.pageTitleValue = res.data.rec[0].caseid;
          vm.loadCaseSubDetailHandler();
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    
    loadCaseSubDetailHandler() {
      const vm = this;

      this.$store.dispatch('get', {url: "/casesubmaintenancedetail/" + this.id})
        .then((res) => {
          console.log('res', res)
          if (res.data.rec.length == 0) {
            vm.loading = false;
            return false
          }

          vm.formData.casesubdetail = res.data.rec;
          
          for (let i = 0; i < vm.formData.casesubdetail.length; i++) {
            if (vm.formData.casesubdetail[i].effectivedate) {
              vm.formData.casesubdetail[i].effectivedate = moment(vm.formData.casesubdetail[i].effectivedate).format('YYYY-MM-DD')
            }

            if (vm.formData.casesubdetail[i].salsuspstartdate) {
              vm.formData.casesubdetail[i].salsuspstartdate = moment(vm.formData.casesubdetail[i].salsuspstartdate).format('YYYY-MM-DD')
            }

            if (vm.formData.casesubdetail[i].salsuspenddate) {
              vm.formData.casesubdetail[i].salsuspenddate = moment(vm.formData.casesubdetail[i].salsuspenddate).format('YYYY-MM-DD')
            }

            if (vm.formData.casesubdetail[i].svsuspstartdate) {
              vm.formData.casesubdetail[i].svsuspstartdate = moment(vm.formData.casesubdetail[i].svsuspstartdate).format('YYYY-MM-DD')
            }

            if (vm.formData.casesubdetail[i].svsuspenddate) {
              vm.formData.casesubdetail[i].svsuspenddate = moment(vm.formData.casesubdetail[i].svsuspenddate).format('YYYY-MM-DD')
            }

            Object.assign(vm.formData.casesubdetail[i], { action: 2 });
            this.casesubid.push(vm.formData.casesubdetail[i].id)
          }
          
          vm.loading = false;
        })
        
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      
      this.$store.dispatch('put', {url: "/casesubmaintenance/" + this.id, 
          payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "casesubmaintenancelist", params: { search: this.search}  });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "casesubmaintenancelist" });
    },

    deleteHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      console.log('delete')
      this.$store.dispatch('delete', {url:
            "/casesubmaintenance/" +
            vm.id +
            "/" +
            this.formData.userid
        })
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "casesubmaintenancelist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    createHandler() {
      this.$router.push({ name: "casesubmaintenancenew" });
    },
  },

  mounted() {
    this.loadCaseSubtHandler(); //header
  },
};
</script>